import Navbar from "../components/Navbar";
import {RiDeleteBin6Line} from "react-icons/ri"
import "../Styles/Cart.css"
import { useEffect, useState } from "react";
import ServiceCard from "../components/ServiceCard";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Cookies from "js-cookie";

const Cart = () => {
    const [cart, setCart] = useState([])
    const [subTotal, setSubTotal] = useState(0.0)
    const [total, setTotal] = useState(0.0)
    
    const increaseQuantity = (id) => {
        const productToEdit = cart.find(item => item.id === id);
        if(productToEdit){
            productToEdit.qty += 1
        }

        localStorage.setItem("cart", JSON.stringify(cart))

    }
    const decreaseQuantity = (id) => {
        const productToEdit = cart.find(item => item.id === id);
        if(productToEdit){
            productToEdit.qty === 1 ? productToEdit.qty = 1 : productToEdit.qty -= 1
        }

        localStorage.setItem("cart", JSON.stringify(cart))
    }

    const removeItem = (id) => {
        const productToRemove = cart.findIndex(item => item.id === id);
        if(productToRemove !== -1){
            cart.splice(productToRemove, 1)
        }

        localStorage.setItem("cart", JSON.stringify(cart))
    }

    useEffect(() => {
        let cart = localStorage.getItem('cart');
        if (!cart || !Cookies.get('TOKEN')) {
            setCart([]);
        } else {
            setCart(JSON.parse(cart))
            let cart2 = JSON.parse(cart)
            let total = cart2.reduce((a, b) => a + (b.discountPrice * b.qty), 0);
            let sub = cart2.reduce((a, b) => a + b.discountPrice, 0);
            setTotal(total)
            setSubTotal(sub)
        }
    }, [increaseQuantity, decreaseQuantity])


    const navigate = useNavigate()

    return<>
        <Navbar/>

        <div className="cartDetailsWrapper">
            <div className="leftCart">
                <h1>Cart({cart.length})</h1>
                {
                    cart.map((data) => {
                        return(
                            <div className="cartCard">
                                <p className="remove" onClick={() => removeItem(data.id)}>
                                    <RiDeleteBin6Line/>
                                    Remove
                                </p>
                                <div className="leftCartInner">
                                    <img src={data.images && data.images[0].url} alt="" />
                                    <div className="cartDetails">
                                        <div className="cartDetailsHeading">
                                            <h3>{data.name}</h3>
                                            <h2>${data.discountPrice}</h2>
                                        </div>
                                            <p className="description">{data.description}</p>
                                        <div className="cartDetailsBottom">
                                            <p><span>Category:</span> {data.category}</p>
                                            <div className="cartCount">
                                                <p className="reduce" onClick={() => decreaseQuantity(data.id)}>-</p>
                                                <p>{data.qty}</p>
                                                <p className="add"  onClick={() => increaseQuantity(data.id)}>+</p>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>

                        )
                    })
                }
            </div>
            <div className="rightCart">
                <h1>Summary</h1>
                <div className="summary">
                    <p><span>Quantity: </span> {cart.length}</p>
                    <p><span>Subtotal: </span> ${subTotal && subTotal.toFixed(2)}</p>
                    <p><span>Total: </span> ${total &&  total.toFixed(2)}</p>
                </div>
                <div className="buttonWrap">
                    <button onClick={() => navigate("/checkout")}>Checkout</button>
                    <button  onClick={() => navigate("/product")}>Continue Shopping</button>
                </div>
            </div>
        </div>

        <ServiceCard/>
        <Footer/>
    </>

}

export default Cart;